import { render } from "./LotusAnimation.vue?vue&type=template&id=776416bc"
import script from "./LotusAnimation.vue?vue&type=script&lang=js"
export * from "./LotusAnimation.vue?vue&type=script&lang=js"

import "./LotusAnimation.vue?vue&type=style&index=0&id=776416bc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__